module.exports = __webpack_public_path__ + "img/index02-En1.e2684023.jpg";